commusoftCommon.filter('removeSpacesThenCapitalize', function ($translate) {
    return function (text) {
        var str = "";
        if((typeof text != "undefined")) {
            text = ""+$translate(text);
            str = text.replace(/[^a-zA-Z0-9]/g,' ');
        }
        return str.substring(0,1).toUpperCase()+str.substring(1);
    };
});